import { IconKeys } from '../../components/common/Icon/IconKeys';

export const generateVehicleTypeName = (category: string): string => {
  switch (category) {
    case 'minibus':
      return 'Minibus';
    case 'truck':
      return 'Truck';
    case 'car':
    default:
      return 'Car';
  }
};

export const generateVehicleTypeIcon = (category?: string): IconKeys => {
  switch (category) {
    case 'minibus':
      return IconKeys.CAR_HATCHBACK;
    case 'truck':
      return IconKeys.TRUCK;
    case 'car':
    default:
      return IconKeys.CAR_OUTLINED;
  }
};
